import { useReducer } from "react";

export const useForceRender = () => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  return forceUpdate;
};
